module.exports = __webpack_public_path__ + "img/rich-menu.dd0d3c7e.png";